import React from 'react';
import './products.scss';
import { connect } from 'react-redux';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import SortAndFilterBar from '../../components/mweb/SortAndFilterBar/SortAndFilterBar';
import ProductCard from '../../components/mweb/ProductCard/ProductCard';
import {
  getCategoryPLPDetails,
  getSectionPLP,
  resetPLP,
} from 'hb-redux-store/feature/products/product.action';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
// import { getCPMapping } from './../../CPMapping';
import ImageOverlay from '../../components/common/ImageOverlay/ImageOverlay';
import { Helmet } from 'react-helmet';
import { AppDownload } from 'components/mweb/AppDownload/AppDownload';
import USP from '../../components/mweb/USP/USP';
class PLP extends React.Component {
  state = {
    showTitle: true,
  };
  componentDidMount() {
    const { categoryId, isProvisional, section } = this.props;
    if (section) {
      this.props.getSectionPLP(section);
    } else {
      this.props.getCategoryPLPDetails({ categoryId, isProvisional });
    }
  }

  componentWillUnmount() {
    this.props.resetPLP();
  }

  render() {
    const {
      categoryPLPDetails,
      loadingCategoryPLP,
      postAddItem,
      postRemoveItem,
      section,
    } = this.props;
    const USP_INDEX = 6;
    const APP_DOWNLOAD_INDEX = 3;
    const { showTitle } = this.state;
    let productsLT3 = categoryPLPDetails?.products || [];
    let productsLT6 = [];
    let productsGT6 = [];
    if (categoryPLPDetails?.products?.length >= APP_DOWNLOAD_INDEX) {
      productsLT3 = [];
      categoryPLPDetails.products.map((p, index) => {
        if (index < APP_DOWNLOAD_INDEX) productsLT3.push(p);
        else if (index >= APP_DOWNLOAD_INDEX && index < USP_INDEX)
          productsLT6.push(p);
        else productsGT6.push(p);
      });
    }
    return (
      <div className="plp">
        {/*<SecondaryNav*/}
        {/*  title={categoryPLPDetails && categoryPLPDetails.categoryName}*/}
        {/*  showTitle={showTitle}*/}
        {/*/>*/}
        <SecondaryNav />
        {loadingCategoryPLP && <Loader />}
        {categoryPLPDetails && !loadingCategoryPLP && (
          <React.Fragment>
            {!section && (
              <Helmet>
                <title>{`Buy Fresh ${categoryPLPDetails.categoryName} Online in Mumbai | Fresh Early Morning Delivery - VegXL`}</title>
                {/*  Twitter Card data  */}
                <meta
                  name="twitter:card"
                  value={`Buy Fresh ${categoryPLPDetails.categoryName} Online in Mumbai | Fresh Early Morning Delivery - VegXL`}
                />
                {/*  Open Graph data  */}
                <meta
                  property="og:title"
                  content={`Buy Fresh ${categoryPLPDetails.categoryName} Online in Mumbai | Fresh Early Morning Delivery - VegXL`}
                />
                <meta
                  property="og:image"
                  content={categoryPLPDetails.mobileBannerImage}
                />
              </Helmet>
            )}
            {categoryPLPDetails?.mobileBannerImage && (
              <ImageOverlay>
                <img
                  src={categoryPLPDetails.mobileBannerImage}
                  className="plp--category-banner-image"
                  alt={`${categoryPLPDetails.categoryName}`}
                />
              </ImageOverlay>
            )}
            {/*<SortAndFilterBar />*/}
            <div className={`plp--heading ${section ? 'section-plp' : ''}`}>
              <h3 className="plp--heading--category-name bold">
                {categoryPLPDetails.categoryName}
              </h3>
              {categoryPLPDetails.subTitle && (
                <div className="plp--heading--sub-text">
                  {categoryPLPDetails.subTitle}
                </div>
              )}
            </div>
            {productsLT3.map(product => {
              return (
                <div className="plp--product-card" key={product.productId}>
                  <ProductCard
                    product={product}
                    onIncrement={postAddItem}
                    onDecrement={postRemoveItem}
                    source="PLP"
                  />
                </div>
              );
            })}
            <div className="plp--usp">
              <AppDownload />
            </div>
            {productsLT6.map(product => {
              return (
                <div className="plp--product-card" key={product.productId}>
                  <ProductCard
                    product={product}
                    onIncrement={postAddItem}
                    onDecrement={postRemoveItem}
                    source="PLP"
                  />
                </div>
              );
            })}
            <div className="plp--usp">
              <USP scrollable={true} />
            </div>
            {productsGT6.map(product => {
              return (
                <div className="plp--product-card" key={product.productId}>
                  <ProductCard
                    product={product}
                    onIncrement={postAddItem}
                    onDecrement={postRemoveItem}
                    source="PLP"
                  />
                </div>
              );
            })}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ productReducer }) => ({
  categoryPLPDetails: productReducer.categoryPLPDetails,
  loadingCategoryPLP: productReducer.loadingPdp,
});

const mapDispatchToProps = {
  getCategoryPLPDetails,
  getSectionPLP,
  postAddItem,
  postRemoveItem,
  resetPLP,
};

export default connect(mapStateToProps, mapDispatchToProps)(PLP);
